import EnemExamSessionsTablePresentation from "home/components/enem_exam/presentations/sessions_table_presentation"
import EnemExamPerformanceByAreaPresentation from "home/components/enem_exam/presentations/performance_by_area_presentation"

export {
  EnemExamSessionsTablePresentation,
  EnemExamPerformanceByAreaPresentation
}
